package com.merkost.handpass.api.enums

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class CategoryIcon(val value: String) {
    @SerialName("electronics") ELECTRONICS("electronics"),
    @SerialName("fashion") FASHION("fashion"),
    @SerialName("home_living") HOME_LIVING("home_living"),
    @SerialName("sports_outdoors") SPORTS_OUTDOORS("sports_outdoors"),
    @SerialName("vehicles") VEHICLES("vehicles"),
    @SerialName("baby_kids") BABY_KIDS("baby_kids"),
    @SerialName("books_music_games") BOOKS_MUSIC_GAMES("books_music_games"),
    @SerialName("hobbies_collectibles") HOBBIES_COLLECTIBLES("hobbies_collectibles"),
    @SerialName("garden_tools") GARDEN_TOOLS("garden_tools"),
    @SerialName("health_beauty") HEALTH_BEAUTY("health_beauty"),
    @SerialName("pet_supplies") PET_SUPPLIES("pet_supplies"),
    @SerialName("other") OTHER("other");

    companion object {
        fun fromDbValue(value: String): CategoryIcon? =
            entries.find { it.value == value }
    }
}
